import styled from "styled-components";

/** The positioning context for a toast centred at the bottom of this region. */
export const Region = styled.div`
  position: relative;
  min-width: 0;
`;
